// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/rda?societaId&stato',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","societaId":"number","numero":"number","anno":"number","etichetta":"string","stato":"APERTA|EVASA|ANNULLATA","note":"string|null","createdAt":"string","createdBy":{"id":"number","nome":"string"},"_count":{"righe":"number"}}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
